import State from './State.js';
export default class StateEndMatch extends State {
    constructor(context) {
        super(context);
        this.name = 'endMatch';

    }
    setup() {


        if (this.context.player1) this.context.player1.ready = false;
        if (this.context.player2) this.context.player2.ready = false;

    }
    action(command, value, player) {
        switch (command) {
            case "playAgain": return this.playAgain(player); break;
            default: this.unknownCommand(command, value, player);
        }
    }
    getActions(player) {
        let actions = [];
        let player1 = this.context.player1;
        let player2 = this.context.player2;

        if (player === "player1" && player1 && !player1.ready) {
          actions.push({ command: "playAgain", value: null });
        }

        if(player === "player2" && player2 && !player2.ready) {
          actions.push({ command: "playAgain", value: null });
        }
       
        return actions;
    }
    playAgain(player) {
        let bothReady = false;
        
        //new
        let player1 = this.context.player1;
        let player2 = this.context.player2;


        //new
        if (player1 && player === "player1") {
            player1.ready = true;
        }
        if (player2 && player === "player2") {
            player2.ready = true;
        }
        if ((player1 && player1.ready && !player1.isDisconnected) && (player2 && player2.ready && !player2.isDisconnected)) {
            bothReady = true;
        }
        
        if (bothReady) {
            this.context.setState("preGame");
            this.context.action("start", null, "player1");
            this.context.action("start", null, "player2");
        }

        return true;
    }
    start() {

        this.context.setState("preGame");
    }
    unknownCommand(command, value, player) {
        this.context.unknownCommand(command, null, player);
    }

}